import styled from '@bd/bdui-styles/emotion';
import { typography } from '../styles';
import ClientRegister from '../bdcoreCandidates/ClientRegister';

export default styled(ClientRegister)`
  .form-heading {
    font-family: ${typography.SerifHead};
    font-weight:700;
    font-style: italic;
  }
  .ClientRegister_formSection {
    width:100%;
    padding:0 20px 40px 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ClientRegister.js